












import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

/**
 * @status stable
 * @published 2.0.0
 * @changelog 2.0.0 Published.
 * @changelog 4.4.0 Added overflowing shadow support.
 * @changelog 4.11.0 Only show horizontal scrollbar when overflowing.
 * @changelog 5.0.0 Provide a table context.
 * @changelog 6.5.2 Change into a lighter design
 */
@Component
export default class JdsTable extends Vue {
    @ActiveProvide('jds.table.context') provideContext = true

    @Prop({type: Boolean, default: false}) empty!: boolean

}
